import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { createQueryClient } from './app/queryClient'
import { installOutboxAutoFlush } from './offline/outbox'
import { invalidateAfterFlush } from './offline/flushInvalidate'
import { initAccent } from './app/accent'
import { initTheme } from './app/theme'
import { App } from './App'
import './design/fonts.css' // Cevio-Markenschriften (self-hosted, CSP-konform) — vor allem anderen.
import './design/tokens.css' // Design-Tokens (Basis-Quelle) ZUERST — definiert die var(--*), auf denen styles.css aufbaut.
import './design/accents.css' // Akzent-Paletten (zweite Token-Quelle) direkt danach — überschreiben nur --accent*.
import './styles.css'

// Gespeichertes Farbschema + Akzentfarbe VOR dem Render auf <html> anwenden — kein Flackern, ohne Inline-Script.
initTheme()
initAccent()

const queryClient = createQueryClient()

// Offline gesicherte Schreibvorgänge beim Boot, bei Reconnect (online) und bei Tab-Fokus zustellen.
// Nach erfolgreich nachgelieferten Mutationen die abhängigen Anzeigen auffrischen (gebuchte Zeit + Stempeluhr).
installOutboxAutoFlush((result) => invalidateAfterFlush(queryClient, result))

// Offline-fähige App-Hülle (public/sw.js): ein Reload ohne Netz lädt App + letzten Datenstand aus dem
// Browser-Cache statt abzubrechen (Simon, 08.07.2026). Nur im Build — der Vite-Dev-Server hat eigene
// Modul-URLs, dort wäre der Cache nur im Weg. Fehler beim Registrieren sind unkritisch (App läuft normal).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root-Element #root fehlt im index.html')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
